import { motion } from "framer-motion"
import { AnimTap } from "libs/style/w24_styling"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  className?: string
}

export const LogosDemo = (props: Props): JSX.Element => {
  return (
    <S_LogosDemo className={props.className}>
      <S_Link
        href="https://www.6am.no/"
        target="_blank"
        rel="noreferrer"
        {...AnimTap}
      >
        <S_Logo src="/logo1.png" $height={30} />
      </S_Link>
      <S_Link
        href="https://proneo.no/"
        target="_blank"
        rel="noreferrer"
        {...AnimTap}
      >
        <S_Logo src="/logo2.png" $height={25} />
      </S_Link>
      <S_Link
        href="https://smartinnovationnorway.com/en/"
        target="_blank"
        rel="noreferrer"
        {...AnimTap}
      >
        <S_Logo src="/logo3.png" $height={40} />
      </S_Link>
      <S_Link
        href="https://www.sparkntnu.no/about-spark/"
        target="_blank"
        rel="noreferrer"
        {...AnimTap}
      >
        <S_Logo src="/logo4.png" $height={40} />
      </S_Link>
      <S_Link
        href="https://aider.no/"
        target="_blank"
        rel="noreferrer"
        {...AnimTap}
      >
        <S_Logo src="/logo5.png" $height={25} />
      </S_Link>
      <S_Link
        href="https://www.venturecup.no/"
        target="_blank"
        rel="noreferrer"
        {...AnimTap}
      >
        <S_Logo src="/logo6.png" $height={50} />
      </S_Link>
      <S_Link
        href="https://www.trondheimtechport.no/"
        target="_blank"
        rel="noreferrer"
        {...AnimTap}
      >
        <S_Logo src="/logo7.png" $height={40} />
      </S_Link>
      <S_Link
        href="https://connectmidt.no/"
        target="_blank"
        rel="noreferrer"
        {...AnimTap}
      >
        <S_Logo src="/logo8.png" $height={40} />
      </S_Link>
      <S_Link
        href="https://www.aceon.io/"
        target="_blank"
        rel="noreferrer"
        {...AnimTap}
      >
        <S_Logo src="/logo9.png" $height={40} />
      </S_Link>
      <S_Link
        href="https://startit.csob.cz/"
        target="_blank"
        rel="noreferrer"
        {...AnimTap}
      >
        <S_Logo src="/logo10.png" $height={40} />
      </S_Link>
    </S_LogosDemo>
  )
}

const S_LogosDemo = styled.div`
  display: flex;
  padding: 0 20px;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  justify-content: center;
  @media only screen and (min-width: 1260px) {
    gap: 60px;
  }
`

const S_Link = styled(motion.a)`
  display: flex;
  align-items: center;
  justify-content: center;
`

const S_Logo = styled.img<{ $height: number }>`
  height: ${props => props.$height}px;
  @media only screen and (min-width: 1260px) {
    height: ${props => 1.5 * props.$height}px;
  }
`
